module.exports = __webpack_public_path__ + "img/next1-white.1dd3243d.png";